<template>
  <div class="mds-loader" :class="{ overlay }">
    <div class="loading-container">
      <div class="spinner" />
      <h2 v-if="title">{{ title }}</h2>
      <p v-if="message">{{ message }}</p>
    </div>
  </div>
</template>

<style lang="scss">
.mds-loader {
  display: flex;
  height: stretch;
  align-items: center;
  justify-content: center;
  padding: 2rem;

  &.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(245, 245, 245, 0.9);
    z-index: 30;
  }
}

.loading-container {
  text-align: center;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #e3e3e3;
  border-top-color: #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 14px;
  box-sizing: border-box;
}

h2 {
  color: #333;
  margin: 0 0 7px;
  font-size: 21px;
  line-height: 21px;
  font-weight: 400;
  font-family: Arial, sans-serif;
}

p {
  color: #666;
  font-size: 14px;
  line-height: 14px;
  margin: 0;
  font-family: Arial, sans-serif;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>

<script lang="ts">
export default defineComponent({
  name: 'VLoader',

  props: {
    /**
     * Заголовок под спиннером
     */
    title: {
      type: String,
      default: null,
    },
    /**
     * Подпись под заголовком
     */
    message: {
      type: String,
      default: null,
    },
    /**
     * Режим оверлея — перекрывает родительский контейнер.
     * Родитель должен иметь position: relative
     */
    overlay: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
